<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2">
    <div class="form-horizontal">
      <div class="row">
        <div [ngClass]="{'col-md-7':!this.hidePrimerStampe,'col-md-12':this.hidePrimerStampe}">
            <div class="form-group row">              
                <label class="col-form-label col-2"><span translate="PODVRSTADOKUMENTASTAVKA.AKTIVAN.SINGULAR"></span></label>
                <div class="col-md-1">
                    <input
                      style="width: 20px;"
                      type="checkbox"
                      name="chkAktivan"
                      class="form-control"
                      formControlName="Aktivan"
                      >
                  </div>
              </div>
            <div class="form-group row">
              <div class="col-md-12">
                 
                 <yt-dropdown-picklist 
                    [ModelName]="'vrstadokumenta'"
                    [GetName]="'get'"
                    [ModelProperty]="'Naziv'"
                    [OrderBy]="'Naziv'"
                    [AllowAddNew]='false'     
                    formControlName="VrstaDokumentaID"               
                    name="cmbVrstaDokumenta"
                    [Label]="'PODVRSTADOKUMENTASTAVKA.VRSTADOKUMENTA.SINGULAR'"
                    #autofocus
                    (OnItemSelected)="onVrstaDokumentaSelect($event)"
                    [ShowHeader]="true"
                    [ShowFooter]="false"
                    [TableColumns]="[{
                      name: 'Naziv', label: 'VRSTADOKUMENTASTAVKA.NAZIV.SINGULAR', visible: true, canHide: false
                    }]">
                  </yt-dropdown-picklist> 

              </div>
            
            </div>
            <div class="form-group row">
                <div class="col-md-8">
                    <!-- [GetParameters]='parameterList' -->
                    <!-- <yt-fw-dropdown
                      [ModelName]="'podvrstadokumenta'"
                      [GetName]="'getByVrstaDokumenta'"   
                      [GetParameters]='parameterList'                 
                      [ModelProperty]="'Naziv'"
                      [OrderBy]="'Naziv'"
                      [AllowAddNew]='false'
                      formControlName="PodVrstaDokumentaID"
                      name="cmbPodVrstaDokumenta"
                      [Type]="ID"
                      [ngClass]="{'is-invalid': submitted && fc.PodVrstaDokumentaID.invalid}"
                      [Label]="'PODVRSTADOKUMENTASTAVKA.PODVRSTADOKUMENTA.SINGULAR'">
                    </yt-fw-dropdown> -->
                  <yt-dropdown-picklist 
                    [ModelName]="'podvrstadokumenta'" 
                    [GetName]="'getByVrstaDokumenta'" 
                    [GetParameters]='parameterList'   
                    [ModelProperty]="'Naziv'" 
                    [OrderBy]="'Naziv'"
                    [AllowAddNew]="false" 
                    formControlName="PodVrstaDokumentaID" 
                    name="cmbPodVrstaDokumenta"
                    [Label]="'PODVRSTADOKUMENTASTAVKA.PODVRSTADOKUMENTA.SINGULAR'"
                    [ShowHeader]="true"
                    [ShowFooter]="false"
                    [TableColumns]="[{
                      name: 'Naziv', label: 'PODVRSTADOKUMENTA.NAZIV.SINGULAR'
                    }]"
                    (OnItemSelected)="onPodVrstaDokumentaSelect($event)"> 
                  </yt-dropdown-picklist> 
                  <div class="form-error" *ngIf="submitted && fc.PodVrstaDokumentaID.invalid">
                      <span *ngFor="let validation of errorMessages.PodVrstaDokumentaID">
                        <span class="error-message" *ngIf="fc.PodVrstaDokumentaID.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                      </span>
                  </div>
                </div>
                <div class="col-md-4">
                  <yt-dropdown-picklist 
                    [ModelName]="'Izvestaj'" 
                    [GetName]="'getByPodvrstaDokumentaAndOrgJedId'" 
                    [GetParameters]='parameterListForIzvestaj'   
                    [ModelProperty]="'Opis'" 
                    [OrderBy]="'Opis'"
                    [AllowAddNew]="false" 
                    formControlName="DefaultIzvestajID" 
                    name="cmbDefaultIzvestaj"
                    [Label]="'PODVRSTADOKUMENTASTAVKA.DEFAULTIZVESTAJ.SINGULAR'"
                    [ShowHeader]="true"
                    [ShowFooter]="false"  
                    [AutoSelect]="true"                  
                  > 
                </yt-dropdown-picklist> 
                <div class="form-error" *ngIf="submitted && fc.DefaultIzvestajID.invalid">
                    <span *ngFor="let validation of errorMessages.DefaultIzvestajID">
                      <span class="error-message" *ngIf="fc.DefaultIzvestajID.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                    </span>
                </div>
                </div>
             </div>
            <div class="form-group row">
                <div class="col-md-8">
                  <yt-input
                    [Type]="'text'"
                    name="txtSifra"              
                    formControlName="Sifra"                            
                    [ngClass]="{'is-invalid': submitted && fc.Sifra.invalid}"
                    [Label]="'PODVRSTADOKUMENTASTAVKA.SIFRA.SINGULAR'"
                    [MaxLength]="3"
                    (OnValueChange)="onSifraChange($event)"
                    >
                  </yt-input>
                    <div class="form-error" *ngIf="submitted && fc.Sifra.invalid">
                      <span *ngFor="let validation of errorMessages.Sifra">
                        <span class="error-message" *ngIf="fc.Sifra.hasError(validation.type)">
                          <span translate="{{validation.message}}"></span>
                        </span>
                      </span>
                    </div>
                </div>
              
              <div class="col-md-4" *ngIf="!jesteAdmin">
                <yt-number-input-v3
                  name="txtDuzinaBroja"              
                  [Label]="'PODVRSTADOKUMENTASTAVKA.DUZINABROJA.SINGULAR'"
                  [FormatString]="'1.0-0'"
                  (OnBlur)="onDuzinaBrojaChange($event)"
                  formControlName="DuzinaBrojaDokumenta"
                  ngbTooltip="{{(duzinaBrojaEnable) ? (tooltipDuzinaBrojaDokumentaEnabled | translate) : (tooltipDuzinaBrojaDokumentaDisabled | translate)}}"
                  >
                </yt-number-input-v3>
              </div>
            </div>

            <div class="form-group row" >
              <div class="col-md-5" *ngIf="!jesteAdmin">
                <yt-input
                  [Type]="'text'"
                  name="txtFormatBrojaPrimer"                                                      
                  [Label]="'PODVRSTADOKUMENTASTAVKA.FORMATBROJAPRIMER.SINGULAR'"
                  [MaxLength]="200"
                  formControlName="PrimerBrojaDokumenta"
                  [disabled]="true"
                >
                </yt-input>
                 
              </div>
              <div class="col-md-4" [hidden]="true">
                <yt-input
                  [Type]="'text'"
                  name="txtFormatBrojaDokumenta"  
                  formControlName="FormatBrojaDokumenta"                                    
                  [ngClass]="{'is-invalid': submitted && fc.FormatBrojaDokumenta.invalid}"
                  [Label]="'PODVRSTADOKUMENTASTAVKA.FORMATBROJADOKUMENTA.SINGULAR'"
                  [MaxLength]="50"
                >
                </yt-input>
                <div class="form-error" *ngIf="submitted && fc.FormatBrojaDokumenta.invalid">
                  <span *ngFor="let validation of errorMessages.FormatBrojaDokumenta">
                    <span class="error-message" *ngIf="fc.FormatBrojaDokumenta.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                  </span>
              </div>                 
              </div>
              <div class="col-md-3" [hidden]="this.hideBrojDecimala">
              <yt-number-input-v3
              name="txtBrojZarada"
              formControlName="BrojDecimala"
              [Label]="'PODVRSTADOKUMENTASTAVKA.BROJDECIMALA.SINGULAR'"
              [ngClass]="{'is-invalid': (submitted && fc.BrojDecimala.invalid)}"
              (OnBlur)="onBrojDecimalaBlur($event)"
              ngbTooltip="{{(brojDecimalaEnable) ? (tooltipBrojDecimalaEnabled | translate) : (tooltipBrojDecimalaDisabled | translate)}}"
              [FormatString]="'1.0-0'"
              >
            </yt-number-input-v3>
            <div class="form-error" *ngIf="submitted && this.baseFormGroup.invalid">
              <span class="error-message"
                *ngIf="this.baseFormGroup.errors && this.baseFormGroup.errors.checkControls && !this.baseFormGroup.errors.checkControls.valid"><span
                  translate="{{this.baseFormGroup.errors.checkControls.message}}"></span>
              </span>
            </div>
            <div class="form-error" *ngIf="submitted && fc.BrojDecimala.invalid">
              <span *ngFor="let validation of errorMessages.BrojDecimala">
                <span class="error-message" *ngIf="fc.BrojDecimala.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
              </span>
          </div>
            </div>
            </div>
          <div class="form-group row">
              <div class="col-md-12">
                <yt-input
                  [Type]="'text'"
                  name="txtNaziv"                          
                  formControlName="Naziv"                          
                  [ngClass]="{'is-invalid': submitted && fc.Naziv.invalid}"
                  [Label]="'PODVRSTADOKUMENTASTAVKA.NAZIV.SINGULAR'"
                  [MaxLength]="200"
                >
                </yt-input>
                  <div class="form-error" *ngIf="submitted && fc.Naziv.invalid">
                    <span *ngFor="let validation of errorMessages.Naziv">
                      <span class="error-message" *ngIf="fc.Naziv.hasError(validation.type)">
                        <span translate="{{validation.message}}"></span>
                      </span>
                    </span>
                  </div>
              </div>
            </div>
           
            <div class="form-group row">
              <div class="col-md-6">
                 <yt-dropdown-picklist 
                    [ModelName]="'osoba'" 
                    [GetName]="'get'" 
                    [ModelProperty]="'Prezime,Ime,Jmbg'" 
                    [OrderBy]="'Prezime'"
                    [AllowAddNew]="true" 
                    [AllowEdit]="true"
                    formControlName="OdgovornoLiceID" 
                    [Label]="'PODVRSTADOKUMENTASTAVKA.ODGOVORNOLICE.SINGULAR'"
                    [Width]="'800px'"
                    [Position]="'left'"
                    [Required]="false"
                    (OnItemSelected)="onOdgovornoLiceSelect($event)"
                    [ngClass]="{'is-invalid': submitted && fc.OdgovornoLiceID.invalid}"
                   >
                  </yt-dropdown-picklist>
                  <div class="form-error" *ngIf="submitted && fc.OdgovornoLiceID.invalid">
                    <span *ngFor="let validation of errorMessages.OdgovornoLiceID">
                      <span class="error-message" *ngIf="fc.OdgovornoLiceID.hasError(validation.type)">
                        <span translate="{{validation.message}}"></span>
                      </span>
                    </span>
                  </div>
                  <!-- <div class="form-error" *ngIf="submitted && this.baseFormGroup.invalid">
                    <span class="error-message" *ngIf="this.baseFormGroup.errors && this.baseFormGroup.errors.checkControls && !this.baseFormGroup.errors.checkControls.valid"><span translate="{{this.baseFormGroup.errors.checkControls.message}}"></span></span>
                  </div> -->
                 
              </div>
              <div class="col-md-6" [hidden]="this.hideBankaID">
                <yt-dropdown-picklist 
                   [ModelName]="'banka'" 
                   [GetName]="'get'" 
                   [ModelProperty]="'Naziv'" 
                   [OrderBy]="'Naziv'"
                   [AllowAddNew]="false" 
                   formControlName="BankaID" 
                   [Label]="'PODVRSTADOKUMENTASTAVKA.BANKA.SINGULAR'"
                   [Width]="'800px'"
                   [Position]="'left'"
                  >
                 </yt-dropdown-picklist>
                 <!-- <div class="form-error" *ngIf="submitted && this.baseFormGroup.invalid">
                  <span class="error-message"
                    *ngIf="this.baseFormGroup.errors && this.baseFormGroup.errors.checkControlsBankaId && !this.baseFormGroup.errors.checkControlsBankaId.valid"><span
                      translate="{{this.baseFormGroup.errors.checkControlsBankaId.message}}"></span>
                  </span>
                </div> -->
                 <div class="form-error" *ngIf="submitted && fc.BankaID.invalid">
                  <span *ngFor="let validation of errorMessages.BankaID">
                    <span class="error-message" *ngIf="fc.BankaID.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                  </span>
              </div>
             </div>
           </div>
           <div class="form-group row">
            <div class="col-md-12">
              <yt-text-area 
                [MaxLength]="2000" 
                name="txtFooter1" 
                formControlName="Footer1" 
                [Label]="'PODVRSTADOKUMENTASTAVKA.FOOTER1.SINGULAR'"
                (OnValueChange)="onFooterChange($event)">
              </yt-text-area>
            </div>
          </div>
          
        </div>
        <div class="col-md-5">         
            <div class="row" id="printSectiondId" [hidden]="this.hidePrimerStampe" style="background-color:#ccc">
                <div>
                    <h3>Pregled izgleda dokumenta</h3>
                    <hr>
                    <form novalidate>
                      <br>
                      <span>{{Item.Naziv}}</span>
                      <hr style="width:170px;text-align:left;margin-left:0;height: 1px; background-color: black;">
                      <b>Broj: </b><span>{{primerBrojDokumenta}}</span>          
                      <br>
                      <b>Datum: </b><span>{{prikaziDatum}}</span>   
                      <br>  
                      <br>   
                      <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p>       
                      <br>  
                      <br> 
                      <span>{{prikaziFooter}}</span>   
                      <br>
                      <br>
                      <div style="text-align:right;" class="ml-auto mr-2">
                          <span>Odgovorno lice</span>   
                          <br>
                          <br>
                          <span>{{odgovornoLice}}</span>
                          <hr style="width:170px;text-align:right;margin-right:0;">
               
                      </div>
                      
                    </form>
                  </div>
            </div>
        </div>
        
      </div>
      <div class="row" [hidden]="Item.ID <= 0">
          <button type="button" class="btn btn-secondary ml-auto mr-2" (click)="PrintTemplate()"><span>{{primerStampeTekst}}</span></button>
      </div>
    </div>
  </form>